<template>
  <Modal
    id="LeaveTypeEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
    :zIndex="9999999900"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="leaveTypeForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                    <FormItem :label="$t('leaveType.field.leave_type_name')" name="leaveTypeName">
                      <Input :placeholder="$t('leaveType.validate.required.leave_type_name')"
                             v-model:value="form.leaveTypeName">
                      </Input>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('leaveType.field.payroll_required')" name="payrollRequired">
                      <Select
                              v-model:value="form.payrollRequired"
                              :placeholder="$t('leaveType.validate.required.payroll_required')"
                              :options="selectList.booleanList"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                      </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('leaveType.field.leave_type_name_en')" name="leaveTypeNameEn">
                      <Input :placeholder="$t('leaveType.validate.required.leave_type_name_en')"
                             v-model:value="form.leaveTypeNameEn">
                      </Input>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { LeaveTypeAdd } from "@/api/LeaveTypeAdd";
import { LeaveTypeEdit } from "@/api/LeaveTypeEdit";


export default {
  name: "LeaveTypeEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idLeaTyp : "",
        leaveTypeName : "",
        payrollRequired : false,
        leaveTypeNameEn : "",
      },
      fileList: {
      },
      selectList: {
        booleanList:[{value: 0,label: '否'},{value: 1,label: '是'}],
      },
      validateRules: {
        idLeaTyp: [
          {
            required: true,
            message: this.$t("leaveType.validate.required.id_lea_typ"),
            trigger: "change",
            type: "number",
          },
        ],
        leaveTypeName: [
          {
            required: true,
            message: this.$t("leaveType.validate.required.leave_type_name"),
            trigger: "change",
          },
        ],
        payrollRequired: [
          {
            required: true,
            message: this.$t("leaveType.validate.required.payroll_required"),
            trigger: "change",
            type: "number",
          },
        ],
        leaveTypeNameEn: [
          {
            required: true,
            message: this.$t("leaveType.validate.required.leave_type_name_en"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
    submit() {
      this.$refs["leaveTypeForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new LeaveTypeAdd();
              break;
            case "edit":
              console.log("edit");
              api = new LeaveTypeEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    // reset data
    _resetData() {
      this.form = {
        idLeaTyp : "",
        leaveTypeName : "",
        payrollRequired : false,
        leaveTypeNameEn : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>